var React = require('react');

function BrandingEmailLogo (props) {
    return React.createElement("svg",props,React.createElement("rect",{"width":"84","height":"42","x":"116","y":"11","fill":"current","fillRule":"evenodd","opacity":"1"}));
}

BrandingEmailLogo.defaultProps = {"width":"315","height":"408","viewBox":"0 0 315 408"};

module.exports = BrandingEmailLogo;

BrandingEmailLogo.default = BrandingEmailLogo;
